{
  "CANNED_MGMT": {
    "HEADER": "Uložené odpovede",
    "LEARN_MORE": "Zistiť viac o pripravených odpovediach",
    "DESCRIPTION": "Pripravené odpovede sú vopred napísané šablóny odpovedí, ktoré vám pomôžu rýchlo reagovať na konverzáciu. Agenti môžu napísať znak '/' nasledovaný skráteným kódom, aby vložili pripravenú odpoveď počas konverzácie. ",
    "HEADER_BTN_TXT": "Pridať pripravenú odpoveď",
    "LOADING": "Načítavajú sa pripravené odpovede...",
    "SEARCH_404": "Neexistujú žiadne položky, ktoré by zodpovedali tejto požiadavke.",
    "LIST": {
      "404": "Žiadne uložené odpovede nie sú k dispozícii pre tento účet.",
      "TITLE": "Manažuj uložené odpovede",
      "DESC": "Pripravené odpovede sú preddefinované šablóny odpovedí, ktoré možno použiť na rýchle odosielanie odpovedí v konverzáciách.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Skrátený kód",
        "CONTENT": "Obsah",
        "ACTIONS": "Akcie",
        "INBOXES": "Schránky"
      },
      "ALL_INBOXES": "Všetky schránky",
      "FILTER": {
        "ALL_INBOXES": "Všetky schránky",
        "NO_INBOX": "Bez schránky",
        "SEARCH_PLACEHOLDER": "Hľadať schránky"
      }
    },
    "ADD": {
      "TITLE": "Pridať pripravenú odpoveď",
      "DESC": "Pripravené odpovede sú preddefinované šablóny odpovedí, ktoré možno použiť na rýchle odosielanie odpovedí v konverzáciách.",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Skrátený kód",
          "PLACEHOLDER": "Zadajte prosím skrátený kód.",
          "ERROR": "Skrátený kód je povinný."
        },
        "SUBJECT": {
          "LABEL": "Predmet (iba e-mail)",
          "PLACEHOLDER": "Voliteľný predmet pre e-mailové odpovede / nové konverzácie"
        },
        "CONTENT": {
          "LABEL": "Správa",
          "PLACEHOLDER": "Napíšte prosím správu, ktorú chcete uložiť ako šablónu pre neskoršie použitie.",
          "ERROR": "Správa je povinná."
        },
        "ATTACHMENTS": {
          "LABEL": "Prílohy"
        },
        "SUBMIT": "Odoslať",
        "INBOXES": {
          "LABEL": "Schránky",
          "PLACEHOLDER": "Vyberte schránky (voliteľné, ponechajte prázdne pre všetky schránky)"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Pripravená odpoveď bola úspešne pridaná.",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k chatovaciemu serveru. Skúste to prosím znova."
      }
    },
    "EDIT": {
      "TITLE": "Upraviť pripravenú odpoveď",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Skrátený kód",
          "PLACEHOLDER": "Zadajte prosím skrátený kód.",
          "ERROR": "Skrátený kód je povinný."
        },
        "SUBJECT": {
          "LABEL": "Predmet (iba e-mail)",
          "PLACEHOLDER": "Voliteľný predmet pre e-mailové odpovede / nové konverzácie"
        },
        "CONTENT": {
          "LABEL": "Správa",
          "PLACEHOLDER": "Napíšte prosím správu, ktorú chcete uložiť ako šablónu pre neskoršie použitie.",
          "ERROR": "Správa je povinná."
        },
        "ATTACHMENTS": {
          "LABEL": "Prílohy"
        },
        "SUBMIT": "Odoslať",
        "INBOXES": {
          "LABEL": "Schránky",
          "PLACEHOLDER": "Vyberte schránky (voliteľné, ponechajte prázdne pre všetky schránky)"
        }
      },
      "BUTTON_TEXT": "Upraviť",
      "API": {
        "SUCCESS_MESSAGE": "Pripravená odpoveď bola úspešne aktualizovaná.",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k chatovaciemu serveru. Skúste to prosím znova."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "API": {
        "SUCCESS_MESSAGE": "Pripravená odpoveď bola úspešne odstránená.",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k chatovaciemu serveru. Skúste to prosím znova."
      },
      "CONFIRM": {
        "TITLE": "Potvrdiť odstránenie",
        "MESSAGE": "Určite chcete vymazať ",
        "YES": "Áno, odstrániť ",
        "NO": "Nie, ponechať "
      }
    }
  }
}
